export const branchDisplay = (branch) => {
  if (typeof branch?.fullName !== 'string' || !branch.fullName.trim()) {
    return { label: '', parts: [], formalName: null, modern: false };
  }
  const parts = branch.nameParts;
  const valid = Array.isArray(parts) && parts.length > 0 && parts.every((part) =>
    part && typeof part.text === 'string' && typeof part.highlight === 'boolean'
  ) && parts.map((part) => part.text).join('') === branch.fullName;
  return {
    label: branch.fullName, formalName: branch.fullName, modern: true,
    parts: valid ? parts : [{ text: branch.fullName, highlight: false }],
  };
};

export const BranchName = ({ branch, highlightClassName, breakClassName }) => (
  <>{branchDisplay(branch).parts.map((part, index) => (
    <span key={index} className={part.highlight ? highlightClassName : undefined}
      style={part.highlight ? undefined : { color: '#000' }}>
      {part.text}
      {breakClassName && index === 0 && part.text === '刀禅' ? <br className={breakClassName} /> : null}
    </span>
  ))}</>
);
